import { render, staticRenderFns } from "./CampusListView.vue?vue&type=template&id=0899205c&scoped=true"
import script from "./CampusListView.vue?vue&type=script&lang=js"
export * from "./CampusListView.vue?vue&type=script&lang=js"
import style0 from "./CampusListView.vue?vue&type=style&index=0&id=0899205c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0899205c",
  null
  
)

export default component.exports